/*
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React from "react";
import { Routes, Route } from "react-router-dom";
import { LoginCallback } from "@okta/okta-react";
import { createTheme, ThemeProvider } from "@mui/material";
import Loader from "../utils/Loader";
import Authenticated from "../authentication/Authenticated";
import Container from "../components/HomeContainer/Container";
import { RequiredAuth } from "./SecurityRoute";
import Home from "../pages/Home";
import AppDynamics from "../AppDynamics";

const theme = createTheme();
const AppRoutes = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppDynamics />
      <Routes>
        <Route
          path="/login/callback"
          element={<LoginCallback loadingElement={<Loader />} />}
        />
        <Route path="" exact={true} element={<Authenticated />} />
        <Route path="/home" element={<RequiredAuth />}>
          <Route path="" element={<Home />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
};

export default AppRoutes;
